export class ObservacoesFixasModel {
  id: string;
  referencia: string = null;
  observacao_pt: string;
  observacao_en: string;
  observacao_es: string;
  cor: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-observacoes-fixas/observacoes-fixas.model.ts